module.exports = __webpack_public_path__ + "static/media/USYGY300001.5f6c25c4.jpg";